/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, reason: NonNullable<unknown> }} Sales_Return_History_FeeInputs */

const vi_sales_return_history_fee = /** @type {(inputs: Sales_Return_History_FeeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phí trả hàng ${i?.amount}: ${i?.reason}`)
};

/**

* @param {Sales_Return_History_FeeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_history_fee = /** @type {((inputs: Sales_Return_History_FeeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_History_FeeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_history_fee(inputs)
});